
<template>
  <div>
    <Spiner :class="statusData.spinnerStatus ? '' : 'display_none'"/>

    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'3-4'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>
            메인화면 관리 - 고정 배너 관리
          </p>
          <div class="Admin_PageHeader_btn">
            <button class="Admin_PageHeader_btn01" v-on:click="check_form">
              수정
            </button>
          </div>
        </div>

        <div class="Admin_PageDetail">
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='fix_banner_title_1'>가로 배너 타이틀<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'fix_banner_title_1'
                maxLength="30"
                placeholder = "가로 배너 타이틀을 입력해 주세요.(30자 이내)"
                v-model="formData.fixBannerTitle1"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.fixBannerTitle1Error}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='fix_banner_link_1'>가로 배너 링크<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'fix_banner_link_1'
                maxLength="200"
                placeholder = "가로 배너 링크를 입력해 주세요."
                v-model="formData.fixBannerLink1"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.fixBannerLink1Error}}</p>
          </div>

          <div class="Admin_imgBanner_BoxWrap">
            <div class="Admin_imgBanner_BoxTit">가로 배너 이미지</div>
            <div class="Admin_imgBanner_Box">
              <div class="Admin_imgBanner_TextBox">
                <p>이미지<span class="pointTextRed"> * </span></p>
                <p class="Admin_imgBanner_SubTit">사이즈 : 1920 x 160px </p>
                <label for='fix_banner_image_1' class="Admin_imgBanner_Btn">
                  변경
                </label>
              </div>

              <div class="Admin_imgBanner_ImgBox">
                <input
                  style="display:none"
                  type='file'
                  id = 'fix_banner_image_1'
                  accept='image/gif, image/jpeg, image/png'
                  @change="changeFixBannerImage"
                />
                <p class="Admin_imgBanner_ImgBox_Common Admin_imgBanner_FixBanner">
                  <img
                    :src="formData.fixBannerImage1URL === '' ? require(`@/assets/images/etc/no_image.gif`) :  formData.fixBannerImage1URL"
                    alt="가로 배로 이미지"
                  />
                </p>
                <p class="Admin_ErrorBox">{{errorData.fixBannerImage1URLError}}</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { ref } from 'vue'
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import Spiner from '../../Homepage/Section/Spiner.vue'
import {
  get_fix_banner_all,
  update_fix_banner
} from '../../ETC/Axios.vue'

export default {
  name: 'AdminFixBannerManagement',
  components: {
    AdminHeader,
    AdminFooter,
    Spiner
  },
  setup () {
    return {
      formData: ref({
        fixBannerTitle1: '',
        fixBannerLink1: '',
        fixBannerImage1: '',
        fixBannerImage1URL: ''
      }),
      errorData: ref({
        fixBannerTitle1Error: '',
        fixBannerLink1Error: '',
        fixBannerImage1URLError: ''
      }),
      statusData: ref({
        spinnerStatus: false
      })
    }
  },
  methods: {
    changeFixBannerImage: function (event_data) {
      if (event_data.target.files[0] !== undefined) {
        this.formData.fixBannerImage1 = event_data.target.files[0]
        const reader = new FileReader()
        reader.readAsDataURL(event_data.target.files[0])
        reader.onloadend = () => {
          this.formData.fixBannerImage1URL = reader.result
        }
      }
    },
    check_form: function () {
      let continue_add = true
      if (this.formData.fixBannerTitle1 === '') {
        this.errorData.fixBannerTitle1Error = '가로 배너 타이틀을 입력해 주세요.'
        continue_add = false
      } else {
        this.errorData.fixBannerTitle1Error = ''
      }
      if (this.formData.fixBannerLink1 === '') {
        this.errorData.fixBannerLink1Error = '가로 배너 링크를 입력해 주세요.'
        continue_add = false
      } else {
        this.errorData.fixBannerLink1Error = ''
      }
      if (this.formData.fixBannerImage1URL === '') {
        this.errorData.fixBannerImage1URLError = '메인 노출 이미지를 등록해 주세요.'
        continue_add = false
      } else {
        this.errorData.fixBannerImage1URLError = ''
      }
      if (continue_add) {
        this.statusData.spinnerStatus = true
        update_fix_banner(
          this.formData.fixBannerTitle1,
          this.formData.fixBannerLink1,
          this.formData.fixBannerImage1
        ).then(() => {
          this.statusData.spinnerStatus = false
          alert('수정이 완료되었습니다.')
        })
      } else {
        alert('필수 입력값을 확인해주세요.')
      }
    }
  },
  mounted () {
    get_fix_banner_all().then((result) => {
      result.forEach(element => {
        if (element.fix_banner_division === 1) {
          this.formData.fixBannerTitle1 = element.fix_banner_title
          this.formData.fixBannerLink1 = element.fix_banner_link
          this.formData.fixBannerImage1URL = element.fix_banner_image
        }
      })
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/MainManagement/AdminFixBannerManagement.vue